
import { Component, Vue, Prop } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import regular from "@/common/regular";
import { addRate, updRate } from "@/api/api-rate";
import rateTable from "./pi-rate-table.vue";
import i18n from "@/config/i18n";
@Component({
  components: {
    "pi-rate-table": rateTable
  }
})
export default class PiModelAdd extends Vue {
  @Prop({
    default: () => {
      return [];
    },
    type: Array
  })
  private devTypeList!: object[];
  private modalShow = false;
  private loading = true;
  private isAdd = true;
  private FormData: objAny = {};
  private acTable: objAny = {};
  private dcTable: objAny = {};
  private delayTable: objAny = {};

  private modalTitle = "";
  private ruleInline: objAny = {
    feeName: [
      {
        required: true,
        message: i18n.t("addRatamanage.feeNamePl"),
        trigger: "blur"
      }
    ],
    delayFreeMinutes: [
      {
        required: true,
        name: i18n.t("addRatamanage.delayFreeMinutes"),
        trigger: "blur",
        validator: regular.int
      }
    ]
  };
  private formItem: objAny = {
    feeName: "",
    delayFreeMinutes: "",
    oprAcFeeInfoAddParams: [],
    oprDcFeeInfoAddParams: [],
    oprDelayFeeAddParams: []
  };

  private itemData: objAny = {};

  public open(key: string, item?: objAny) {
    if (key === "sys") {
      this.modalTitle = i18n.t("addRatamanage.add") + "";
    } else if (key === "oms") {
      this.modalTitle = i18n.t("addRatamanage.addOper") + "";
    }
    if (!this.FormData.$el) {
      this.$nextTick((): void => {
        this.FormData = this.$refs["formItem"];
        // this.delayTable = this.$refs["delayTable"];
        this.acTable = this.$refs["acTable"];
        this.dcTable = this.$refs["dcTable"];
      });
    } else {
      this.handleReset();
    }
    this.modalShow = true;

    this.$nextTick((): void => {
      if (item) {
        // 修改
        this.itemData = item;
        this.isAdd = false;
        this.formItem.feeName = item.feeName;
        this.formItem.delayFreeMinutes = item.delayFreeMinutes;
        this.acTable.initData(item.oprAcFeeInfos);
        this.dcTable.initData(item.oprDcFeeInfos);
        // this.delayTable.initData(item.oprDelayFeeInfos);
      } else {
        this.itemData = {};
        this.formItem.feeName = "";
        this.formItem.delayFreeMinutes = "";
        this.acTable.initData();
        this.dcTable.initData();
        // this.delayTable.initData();
        this.isAdd = true;
      }
    });
  }

  /**
   * 把例如12:30转换为1230
   * @param data 小时*100+分钟
   */
  public convertTimesToString(data: string): number {
    const times = data.split(":");
    const str = Number(times[0]) * 100 + Number(times[1]);
    return str;
  }
  /**
   * 分开时间08:00,12:00
   * @param data [{timeQuantum: ['12:30-15:40']}],
   *@param  processData [{beginTime:1230,endTime:1540}]
   */
  public splitDate(data: objAny[]) {
    console.log(data);
    // let dataArray: objAny[];
    // return dataArray;
  }

  /**
   * 把例如1230转为12:30
   * @param data 08：00
   * @param processData
   */
  public convertStringToTimes(data: string | number) {
    const hour = String(Math.floor(Number(data) / 100)).padStart(2, "0");
    const min = String(Number(data) % 100).padStart(2, "0");
    const time = hour + ":" + min;
    return time;
  }
  /**
   * 合并时间 08:00-12:00
   */
  public joinDate(data: string[]) {
    let timeArr = "";
    if (data.length > 0) {
      timeArr =
        this.convertStringToTimes(data[0]) +
        "-" +
        this.convertStringToTimes(data[1]);
      return timeArr;
    }
  }
  public addFormData() {
    console.log("add");
  }

  public handleSubmit(): void {
    this.loading = true;
    this.FormData.validate((valid: boolean) => {
      if (valid) {
        this.validateTable();
      } else {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true;
        });
      }
    });
  }
  public closeModal(): void {
    this.modalShow = false;
  }
  public handleReset() {
    this.FormData.resetFields();
  }

  public validateTable(): void {
    if (
      this.acTable.validate() &&
      this.dcTable.validate()
      // &&
      // this.delayTable.validate()
    ) {
      const oprAcFeeInfoAddParams = this.acTable.returnData();
      const oprDcFeeInfoAddParams = this.dcTable.returnData();
      // const oprDelayFeeAddParams = this.delayTable.returnData();
      this.formItem.oprAcFeeInfoAddParams = oprAcFeeInfoAddParams;
      this.formItem.oprDcFeeInfoAddParams = oprDcFeeInfoAddParams;
      // this.formItem.oprDelayFeeAddParams = oprDelayFeeAddParams;
      this.submitData();
    }
  }
  async submitData(): Promise<void> {
    this.loading = true;
    if (this.itemData.feePkId) {
      const json: objAny = {};
      json["acElecFeePkId"] = this.itemData.acElecFeePkId;
      json["acElecFeePkId"] = this.itemData.acElecFeePkId;
      json["bindStaNum"] = this.itemData.bindStaNum;
      json["dcElecFeePkId"] = this.itemData.dcElecFeePkId;
      json["delayFeePkId"] = this.itemData.delayFeePkId;
      json["feePkId"] = this.itemData.feePkId;
      json["modifyTime"] = this.itemData.modifyTime;
      json["oprPkId"] = this.itemData.oprPkId;

      json["feeName"] = this.formItem.feeName;
      json["delayFreeMinutes"] = this.formItem.delayFreeMinutes;
      json["oprAcFeeInfoUpdParams"] = this.formItem.oprAcFeeInfoAddParams;
      json["oprDelayFeeUpdParams"] = this.formItem.oprDelayFeeAddParams;
      json["oprDcFeeInfoUpdParams"] = this.formItem.oprDcFeeInfoAddParams;
      const ret = await updRate(json);
      if (ret.status === this.$config.apiStatus) {
        this.$Message.success(i18n.t("operationSucess"));
        this.$emit("success");
        this.modalShow = false;
      }
    } else {
      const ret = await addRate(this.formItem);
      if (ret.status === this.$config.apiStatus) {
        this.$Message.success(i18n.t("operationSucess"));
        this.$emit("success");
        this.modalShow = false;
      }
    }
    this.loading = false;
  }
}
